
import React, { createContext, useState, useContext } from 'react';

const ContactFormContext = createContext();

export const ContactFormContextProvider = ({ children }) => {
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);

  const openContactForm = () => setIsContactFormOpen(true);
  const closeContactForm = () => setIsContactFormOpen(false);

  return (
    <ContactFormContext.Provider value={{ isContactFormOpen, openContactForm, closeContactForm }}>
      {children}
    </ContactFormContext.Provider>
  );
};

export const useContactForm = () => useContext(ContactFormContext);
